import React from "react";
import "../../App.css";
import CardGrid from "../CardGrid.js";
import NavItem from "../NavItem.js";

export default function Home({ menuItems, subMenuItemsDict }) {
  return (
    <div className="home">
      {/* Sidebar Section */}
      <div className="menuBar">
        {menuItems.map((menuItem, index) => (
          <NavItem
            text={menuItem}
            key={index}
            dropDownMenuItems={subMenuItemsDict[menuItem]}
          />
        ))}
      </div>

      {/* Main Content Section */}
      <div className="mainContent">
        <CardGrid />

        <div className="poweredBy">
          <span className="poweredText">Powered by </span>
          <a
            href="https://techiteasy.co.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="poweredLink"
          >
            Tech It Easy
          </a>
        </div>
      </div>
    </div>
  );
}
